define('plugin/back-to-site/view/BackToSiteView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    return LayoutView.extend({

        template: '#back_to_site_view',

        _timeout: 0,
        _start: 0,
        _timer: null,

        initialize: function () {
            this.listenTo(this.model, 'sync', this.setupTimer);
            this.setupTimer();
        },

        setupTimer: function () {
            this._timeout = this.model.get('timeout');
            this._start = new Date().getTime();

            if (this.model.get('timer_enabled')) {
                if (this.model.get('instant')) {
                    this.render();
                    this._redirect();

                    return;
                }

                this._timer = setInterval(_.bind(this.handleTimer, this), 500);
            }
            this.render();
        },

        handleTimer: function () {
            if (!this.isDestroyed) {
                this.render();
            } else {
                clearInterval(this._timer);

                return;
            }
            if (this._getLeftTime() > this._timeout) {
                this._redirect();

                if (this._timer) {
                    clearInterval(this._timer);
                }
            }
        },

        _redirect: function () {
            var url = (Utils.isMobile() && this.model.get('mobile_link') != '')
                ? this.model.get('mobile_link')
                : this.model.get('link');

            if (!url) {
                // Nothing configured to redirect to - leave the rendered fallback button as is
                // instead of navigating top to an empty URL, which just reloads the current
                // top-level page (the merchant's own site, in the widget case).
                return;
            }

            try {
                top.window.location = url;
            } catch (e) {
                // top may be cross-origin (widget re-embedded in an iframe) and refuse a
                // script-initiated navigation without a user gesture; the rendered
                // "back to site" button (target="_top") is left as the manual fallback.
            }
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.seconds_to_redirect = Math.max(0, parseInt(this._timeout - this._getLeftTime()));
            result.has_link = !!this.model.get('link');
            result.has_mobile_link = !!this.model.get('mobile_link');
            result.has_any_link = result.has_link || result.has_mobile_link;

            return result;
        },

        _getLeftTime: function () {
            return (new Date().getTime() - this._start) / 1000;
        }

    });

});
